/// <reference path="../../../app.definition.ts" />

interface IEcvClickScope extends ng.IScope {
    ecvClick: () => ng.IPromise<any>;
}

function ecvClick(): ng.IDirective {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            'ecvClick': '&'
        },
        // 2. Use the new interface in the link function
        link: (scope: IEcvClickScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller): void => {
            $(element).attr('role', 'button');
            $(element).click(function (event) {
                if (element.is('a[disabled]')) {
                    event.preventDefault();
                    return;
                }
                $(element).mouseleave();//this is to hide tool tip when button is clicked
                $(element).prop('disabled', true).addClass('ecv-disabled');
                scope.ecvClick().finally(function () {
                    $(element).prop('disabled', false).removeClass('ecv-disabled');
                });
            });
            scope.$on('$destroy', function () {
                $(element).off('click');
            })
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvClick', ecvClick);
